<template>
  <div>
    <div v-show="capshow" class="shade">
    </div>
    <div v-show="capshow" class="cap" :style="{width: capWidth}">
      <div class="test">
        <cut-base
          ref="cropper2"
          :img="example2.img"
          :outputSize="example2.size"
          :outputType="outputType"
          :info="example2.info"
          :canScale="example2.canScale"
          :autoCrop="example2.autoCrop"
          :autoCropWidth="example2.autoCropWidth"
          :autoCropHeight="example2.autoCropHeight"
          :fixed="example2.fixed"
          :fixedNumber="fixedNumber">
        </cut-base>
        <div class="btns">
          <button @click="finish2()" class="sure">确定</button>
          <button @click="cancel" class="cancel">取消</button>
        </div>
      </div>
    </div>
    <div class="media">
      <div class="media-left">
        <div class="icon-block width-100 bg-grey-100 relative cut_relative_box" :style="{width: '200px', height: 200 / parseInt(fixedNumber[0]) * parseInt(fixedNumber[1]) + 'px'}">
          <loading-img :style="{width: '200px', height: 200 / parseInt(fixedNumber[0]) * parseInt(fixedNumber[1]) + 'px'}" v-if="!modelSrc && outSrc !== ''" class="db" :src="outSrc"></loading-img>
          <img :style="{width: '200px', height: 200 / parseInt(fixedNumber[0]) * parseInt(fixedNumber[1]) + 'px'}" v-if="modelSrc" class="db" :src="modelSrc">
          <div class="cut_absolute_box" :style="{width: '200px', height: 200 / parseInt(fixedNumber[0]) * parseInt(fixedNumber[1]) + 'px'}">
            <label class="relative cut_relative_label pointer" :class="{'cut_relative_hover': modelSrc || outSrc}" :for="id">
              <input ref="inputFile" type="file" :id="id" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event, 2)">
              <div class="cut_absolute_explain">
                <img class="mauto db m-b-10 m-t-20" style="max-width: 40px;" src="./upload.png">
                <p class="fs12 condition text-center">
                  点击上传图片
                </p>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div class="media-body m-l-15">
        <p class="fs12 condition word_wrap_break">
          {{prompt}}  <!-- * 图片类型必须是.gif,jpeg,jpg,png,bmp中的一种 -->
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  import cutBase from './cut-base.vue'
  import ajax from 'utils/ajax.js'
  import loadingImg from './loading'
  export default {
    data () {
      return {
        imgFile: null,
        model: false,
        modelSrc: '',
        example2: {
          img: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC',
          info: true,
          canScale: true,
          autoCrop: true,
          // 只有自动截图开启 宽度高度才生效
          autoCropWidth: 300,
          autoCropHeight: 250,
          fixed: true,
          fixedNumber: [1, 1]
        },
        capshow: false
      }
    },
    // props: ['fixedNumber', 'outputType', 'size'],
    props: {
      type: {
        type: String,
        required: true
      },
      capWidth: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: 'cut-id'
      },
      isOriginal: {
        type: Boolean,
        default: false
      },
      outSrc: {
        type: String,
        default: ''
      },
      limitSize: {
        type: Number,
        default: 5
      },
      fixedNumber: {
        type: Array,
        default: () => {
          return [1, 1]
        }
      },
      outputType: {
        type: String,
        default: 'jpeg'
      },
      size: {
        type: Number,
        default: 1
      },
      prompt: {
        type: String,
        default: ''
      }
    },
    components: {
      cutBase,
      loadingImg
    },
    watch: {
      outSrc (e) {
        if (!e) { this.modelSrc = '' }
      },
      modelSrc (val) {
        if (val) {
          var byteString
          if (val.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(val.split(',')[1])
          } else {
            byteString = unescape(val.split(',')[1])
          }
          var mimeString = val.split(',')[0].split(':')[1].split(';')[0]
          var ia = new Uint8Array(byteString.length)
          for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i)
          }
          if (this.isOriginal) {
            ajax.upload(this.imgFile, this.type).then((res) => {
              this.$emit('change', res.data.key)
            })
          } else {
            ajax.upload(new Blob([ia], { type: mimeString }), this.type).then((res) => {
              this.$emit('change', res.data.key)
            })
          }
        }
      }
    },
    methods: {
      cancel () {
        this.capshow = false
      },
      uploadImg (e, num) {
        // 上传图片
        // this.option.img
        if (!e.target.files[0].type || e.target.files[0].type.indexOf('image')) {
          this.$awn.alert('请选择图片文件！')
          return
        }
        this.imgFile = e.target.files[0]
        // console.log(this.imgFile.lastModifiedDate)
        var file = e.target.files[0]
        if ((file.size / 1024 / 1024) > this.limitSize) {
          this.$awn.warning('上传图片大小不得超过' + this.limitSize + 'M！')
          this.$refs.inputFile.value = ''
        } else {
          var reader = new FileReader()
          reader.onload = (e) => {
            let data
            if (typeof e.target.result === 'object') {
              // 把Array Buffer转化为blob 如果是base64不需要
              data = window.URL.createObjectURL(new Blob([e.target.result]))
            } else {
              data = e.target.result
            }
            if (num === 1) {
              this.option.img = data
            } else if (num === 2) {
              this.example2.img = data
            }
          }
          // 转化为base64
          // reader.readAsDataURL(file)
          // 转化为blob
          reader.readAsArrayBuffer(file)
          this.capshow = true
        }
      },
      finish2 () {
        this.$refs.inputFile.value = ''
        this.$refs.cropper2.getCropData((data) => {
          this.modelSrc = data
          this.capshow = false
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .media{
    border: 0 !important;
    padding: 0 !important;
  }
  .cut_relative_box{
    background: #f5f5f5;
    overflow: hidden;
    border-radius: 6px;
    .cut_absolute_box{
      position: absolute;
      top: 0;
      .cut_relative_label{
        &.cut_relative_hover{
          transition: 0.5s;
          -moz-transition: 0.5s;	/* Firefox 4 */
          -webkit-transition: 0.5s;	/* Safari 和 Chrome */
          -o-transition: 0.5s;	/* Opera */
          opacity: 0;
        }
        color: #666;
        background: rgba(0, 0, 0, 0.05);
        margin: 0;
        padding: 0;
        top: 0;
        width: 100%;
        height: 100%;
        .cut_absolute_explain{
          width: 100%;
          left: 0;;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      &:hover{
        .cut_relative_hover{
          opacity: 1;
        }
      }
    }
  }
  .shade{
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
  }
  .cap{
    position: fixed;
    width: 50%;
    height: 576px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 101;
    /* border: 26px solid #eee; */
    background: #fff;
    padding: 25px;
    /* border: 2px solid rgba(0,0,0,0.2); */
    background-color: white;
    box-shadow: 0 0 13px rgba(0,0,0,0.7);
    border-radius: 3px;
  }
  .condition-btn{
    background: #ffffff;
    border: 1px solid #cacaca;
    color: #484746;
    margin-top: 0px;
    margin-bottom: 8px;
  }
  .btns{
    padding-top: 10px;
    float: right;
  button{
    width: 66px;
    height: 32px;
    border-radius: 5px;
    background: #f1f1f1;
    border: 1px solid #dddddd;
    text-align: center;
    line-height: 30px;
  }
  .sure{
    background: #4087EC;
    color: #ffffff;
  }
}
  .show-info {
		margin-bottom: 50px;
	}

	.show-info h2 {
		line-height: 50px;
  }
  .test {
	  height: 500px;
  }
  .model {
		position: fixed;
		z-index: 10;
		width: 100vw;
		height: 100vh;
		overflow: auto;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.8);
	}

	.model-show {
		display: flex;
    justify-content: center;
    align-items: center;
		width: 100vw;
		height: 100vh;
	}

	.model img {
		display: block;
		margin: auto;
		max-width: 80%;
		user-select: none;
		background-position: 0px 0px, 10px 10px;
		background-size: 20px 20px;
    background-image: linear-gradient(45deg, #eee 25%, transparent 25%, transparent 75%, #eee 75%, #eee 100%),linear-gradient(45deg, #eee 25%, white 25%, white 75%, #eee 75%, #eee 100%);
	}

	@keyframes slide {
    0%  {
      background-position: 0 0;
    }
    100% {
      background-position: -100% 0;
    }
  }
  .word_wrap_break{
    word-wrap: break-word;
    word-break: break-all;
  }
</style>



// WEBPACK FOOTER //
// src/components/upload/cut.vue